import { IkpiModalTableStructure } from '@component/Modules/Kpi/Modal'

const currentYear = String(new Date().getFullYear())
const lastYear = String(new Date().getFullYear() - 1)

export const kpiModalTableStructure: IkpiModalTableStructure[] = [
  {
    group: 'Período',
    columns: [
      {
        name: '',
        id: 'periodo-id',
        show: true
      }
    ]
  },
  {
    group: 'Venda Líquida R$',
    columns: [
      {
        name: lastYear,
        id: 'venda-liquida-lastYear-id',
        show: true
      },
      {
        name: currentYear,
        id: 'venda-liquida-currentYear-id',
        show: true
      },
      {
        name: '%',
        id: 'porcentagem-venda-liquida-id',
        show: true
      }
    ]
  },
  {
    group: 'Venda Líquida BTLeo',
    columns: [
      {
        name: lastYear,
        id: 'venda-liquida-btleo-lastYear-id',
        show: true
      },
      {
        name: currentYear,
        id: 'venda-liquida-btleo-currentYear-id',
        show: true
      },
      {
        name: '%',
        id: 'valor-venda-liquida-btleo-id',
        show: true
      }
    ]
  },
  {
    group: 'Margem R$',
    columns: [
      {
        name: lastYear,
        id: 'margem-lastYear-id',
        show: true
      },
      {
        name: currentYear,
        id: 'margem-currentYear-id',
        show: true
      },
      {
        name: '%',
        id: 'valor-margem-id',
        show: true
      }
    ]
  },
  {
    group: 'Margem %',
    columns: [
      {
        name: lastYear,
        id: 'porcentagem-margem-lastYear-id',
        show: true
      },
      {
        name: currentYear,
        id: 'porcentagem-margem-currentYear-id',
        show: true
      },
      {
        name: '%',
        id: 'valor-porcentagem-margem-id',
        show: true
      }
    ]
  }
]
